// @ts-strict-ignore
import { Dictionary } from 'typescript-collections';
import { ConverterHelper } from './converter.helper';
import { LocalizedPropertyValueVO, PropertyVO, StringValueInLocalesVO } from '@project/components/article/model/vo/property.vo';
import { RepresentationDataVO, RepresentationVO } from '../vo/representation.vo';
import { MetaElementUsageVO, MetaElementVO, TextValueVO } from '../vo/meta-element.vo';
import { ArticleVO } from '@article/model/vo/article.vo';
import { JsonConverter, JsonCustomConvert } from './convert-core';
import { ProjectVO } from '@project/model/vo/project.vo';
import { TextSizeCheckRequestVO, TextSizeCheckVO } from '@3d-scene/manager/text-size-check.vo';
import { ArticleDescriptorVO, ElementReferenceVO, QuickFixActionVO } from '@project/model/vo/validation-context.vo';
import { ArticleWithTechnicalPropertiesDTO } from '@article/properties/technical/technical-requirements';

@JsonConverter('DateConverter')
export class DateConverter implements JsonCustomConvert<Date> {
  deserialize(object: any): Date {
    if (!object) {
      return null;
    }
    return new Date(object);
  }
}

@JsonConverter('PropertyVOConverter')
export class PropertyVOConverter implements JsonCustomConvert<PropertyVO> {
  deserialize(object: any): PropertyVO {
    return ConverterHelper.convertToPropertyVO(object);
  }
}

@JsonConverter('RepresentationDataVOConverter')
export class RepresentationDataVOConverter implements JsonCustomConvert<RepresentationDataVO> {
  deserialize(object: any): RepresentationDataVO {
    return ConverterHelper.convertToRepresentationDataVO(object);
  }
}

@JsonConverter('MetaElementVOsConverter')
export class MetaElementVOsConverter implements JsonCustomConvert<MetaElementVO[]> {
  deserialize(object: any): MetaElementVO[] {
    return ConverterHelper.convertToMetaElementVOs(object);
  }
}

@JsonConverter('MetaElementUsageVOsConverter')
export class MetaElementUsageVOsConverter implements JsonCustomConvert<MetaElementUsageVO[]> {
  deserialize(object: any): MetaElementUsageVO[] {
    return ConverterHelper.convertToMetaElementUsageVOs(object);
  }
}

@JsonConverter('TextValueVOConverter')
export class TextValueVOConverter implements JsonCustomConvert<TextValueVO> {
  deserialize(object: any): TextValueVO {
    return ConverterHelper.convertToTextValueVO(object);
  }
}

@JsonConverter('StringValueInLocalesVOConverter')
export class StringValueInLocalesVOConverter implements JsonCustomConvert<StringValueInLocalesVO> {
  deserialize(object: any): StringValueInLocalesVO {
    return ConverterHelper.convertToStringValueInLocalesVO(object);
  }
}

@JsonConverter('RepresentationVOsConverter')
export class RepresentationVOsConverter implements JsonCustomConvert<RepresentationVO[]> {
  deserialize(object: any): RepresentationVO[] {
    return ConverterHelper.convertToRepresentationVOs(object);
  }
}

@JsonConverter('StringArticleVODictionaryConverter')
export class StringArticleVODictionaryConverter implements JsonCustomConvert<Dictionary<string, ArticleVO>> {
  deserialize(object: any): Dictionary<string, ArticleVO> {
    return ConverterHelper.convertToStringArticleVODictionary(object);
  }
}

@JsonConverter('StringProjectVODictionaryConverter')
export class StringProjectVODictionaryConverter implements JsonCustomConvert<Dictionary<string, ProjectVO>> {
  deserialize(object: any): Dictionary<string, ProjectVO> {
    return ConverterHelper.convertToStringProjectVODictionary(object);
  }
}

@JsonConverter('TextSizeCheckRequestVOConverter')
export class TextSizeCheckRequestVOConverter implements JsonCustomConvert<TextSizeCheckRequestVO> {
  deserialize(object: any): TextSizeCheckRequestVO {
    return ConverterHelper.convertToTextSizeCheckRequestVO(object);
  }
}

@JsonConverter('TextSizeCheckVOsConverter')
export class TextSizeCheckVOsConverter implements JsonCustomConvert<TextSizeCheckVO[]> {
  deserialize(object: any): TextSizeCheckVO[] {
    return ConverterHelper.convertToTextSizeCheckVOs(object);
  }
}

@JsonConverter('ArticleVOConverter')
export class ArticleVOConverter implements JsonCustomConvert<ArticleVO> {
  deserialize(object: any): ArticleVO {
    return ConverterHelper.convertToArticleVO(object);
  }
}

@JsonConverter('ArticleVOsConverter')
export class ArticleVOsConverter implements JsonCustomConvert<ArticleVO[]> {
  deserialize(object: any): ArticleVO[] {
    return ConverterHelper.convertToArticleVOs(object);
  }
}

@JsonConverter('QuickFixActionVOsConverter')
export class QuickFixActionVOsConverter implements JsonCustomConvert<QuickFixActionVO[]> {
  deserialize(object: any): QuickFixActionVO[] {
    return ConverterHelper.convertToQuickFixActionVOs(object);
  }
}

@JsonConverter('ArticleDescriptorVOConverter')
export class ArticleDescriptorVOConverter implements JsonCustomConvert<ArticleDescriptorVO> {
  deserialize(object: any): ArticleDescriptorVO {
    return ConverterHelper.convertToArticleDescriptorVO(object);
  }
}

@JsonConverter('ElementReferenceVOsConverter')
export class ElementReferenceVOsConverter implements JsonCustomConvert<ElementReferenceVO[]> {
  deserialize(object: any): ElementReferenceVO[] {
    return ConverterHelper.convertToElementReferenceVOs(object);
  }
}

@JsonConverter('LocalizedPropertyValueVOsConverter')
export class LocalizedPropertyValueVOsConverter implements JsonCustomConvert<LocalizedPropertyValueVO[]> {
  deserialize(object: any): LocalizedPropertyValueVO[] {
    return ConverterHelper.convertToLocalizedPropertyValueVOs(object);
  }
}

@JsonConverter('ArticleWithTechnicalPropertiesConverter')
export class ArticleWithTechnicalPropertiesConverter implements JsonCustomConvert<ArticleWithTechnicalPropertiesDTO> {
  deserialize(object: any): ArticleWithTechnicalPropertiesDTO {
    return object as ArticleWithTechnicalPropertiesDTO;
  }
}
